module.exports = __webpack_public_path__ + "static/media/CV_HELLO.eaecc88b.png";